import { useQuery } from '@tanstack/react-query';
import { getTypeDocumentsIdentification } from '@/services/generic';

export const useTypeDocumentIdentification = () => {
  const queryKey = ['type-document-identification'];
  return useQuery({
    queryKey,
    queryFn: getTypeDocumentsIdentification,
    select: (data) => ({
      originalData: data,
      select: data.map((item) => ({
        label: item.name,
        value: item.id,
      })),
    }),
  });
};
